module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-filled.07738af6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-filled/fonts/Pe-icon-7-filled.svg?kinggk
 ** module id = 1601
 ** module chunks = 0
 **/